// extracted by mini-css-extract-plugin
export default {"grid":"ProfileNfts_grid__Js3JX"};